// These are production canonical URLs
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    URLS: ()=>URLS,
    PROJECTS: ()=>PROJECTS,
    USER_PROFILE_SECTION_PATHS: ()=>USER_PROFILE_SECTION_PATHS,
    USER_PROFILE_SHOP_SUB_PATHS: ()=>USER_PROFILE_SHOP_SUB_PATHS,
    USER_PROFILE_POSTS_SUB_PATHS: ()=>USER_PROFILE_POSTS_SUB_PATHS,
    USER_PROFILE_BACKROOM_SUB_PATHS: ()=>USER_PROFILE_BACKROOM_SUB_PATHS,
    DEVIATION_PATHS: ()=>DEVIATION_PATHS,
    CONTACT_PAGE_ANCHOR_JUMP_POINTS: ()=>CONTACT_PAGE_ANCHOR_JUMP_POINTS,
    SHOP_PATHS: ()=>SHOP_PATHS,
    CHECKOUT_IDS: ()=>CHECKOUT_IDS
});
var URLS;
(function(URLS) {
    URLS["ROOT"] = 'https://www.deviantart.com';
    URLS[// the following are non-node URLs
    "ABOUT"] = 'https://www.deviantart.com/about';
    URLS["ADVERTISE"] = 'https://deviantartads.com';
    URLS["CAREERS"] = 'https://www.deviantart.com/team/journal/Careers-at-DeviantArt-855261915';
    URLS["CART"] = 'https://www.deviantart.com/checkout/';
    URLS["COMMISSIONS"] = 'https://www.deviantart.com/commissions';
    URLS["CONTACT"] = 'https://www.deviantartsupport.com/en/article/how-do-i-contact-deviantart';
    URLS["COPYRIGHT"] = 'https://www.deviantart.com/about/policy/copyright/';
    URLS["COPYRIGHT_POLICY"] = 'https://www.deviantartsupport.com/en/article/the-copyright-policy';
    URLS["CORE_MEMBERSHIP"] = 'https://www.deviantart.com/core-membership';
    URLS["DEVELOPERS"] = 'https://www.deviantart.com/developers';
    URLS["DREAMUP_POLICY"] = 'https://www.deviantart.com/about/policy/dreamup/';
    URLS["EARNINGS"] = 'https://www.deviantart.com/account/earnings/';
    URLS["EARNINGS_DOWNLOAD"] = 'https://www.deviantart.com/account/earnings/download_csv/';
    URLS["ETIQUETTE"] = 'https://www.deviantart.com/about/policy/etiquette';
    URLS["FEEDBACK"] = 'https://www.deviantartsupport.com/en/eclipse';
    URLS["FORUM"] = 'https://www.deviantart.com/forum';
    URLS["GROUPS"] = 'https://www.deviantart.com/groups';
    URLS["HELP"] = 'https://www.deviantartsupport.com/en/';
    URLS["HELP_NEW_TICKET"] = 'https://contact.deviantartsupport.com/en';
    URLS["LOGOUT"] = 'https://www.deviantart.com/users/logout';
    URLS["MLT"] = 'https://www.deviantart.com/morelikethis';
    URLS["NOTES"] = 'https://www.deviantart.com/notifications/notes';
    URLS["OAUTH_AUTHORIZE"] = 'https://www.deviantart.com/oauth2/authorize';
    URLS["ORDERS"] = 'https://www.deviantart.com/account/';
    URLS["POINTS"] = 'https://www.deviantart.com/account/points/';
    URLS["ABOUT_POINTS"] = 'https://www.deviantartsupport.com/en/article/what-are-points-1749105';
    URLS["POINTS_POLICY"] = 'https://www.deviantart.com/about/policy/points/';
    URLS["POLLS"] = 'https://www.deviantart.com/polls';
    URLS["PRINTS_POLICY"] = 'https://www.deviantart.com/about/policy/prints/agreement/';
    URLS["PRINTS_PRICES"] = 'https://www.deviantartsupport.com/en/article/what-are-the-base-prices-for-prints';
    URLS["PRINTS_HOWTO"] = 'https://www.deviantartsupport.com/en/article/how-do-i-submit-my-deviation-as-a-print';
    URLS["PRIVACY"] = 'https://www.deviantart.com/about/policy/privacy';
    URLS["SETTINGS"] = 'https://www.deviantart.com/settings/identity';
    URLS["SETTINGS_GENERAL"] = 'https://www.deviantart.com/settings/general';
    URLS["SETTINGS_BILLING"] = 'https://www.deviantart.com/settings/billing_and_payments';
    URLS["SETTINGS_REBILLING"] = 'https://www.deviantart.com/settings/rebilling';
    URLS["SETTINGS_SUBSCRIPTIONS"] = 'https://www.deviantart.com/settings/subscriptions';
    URLS["PRINTS"] = 'https://www.deviantart.com/prints';
    URLS["SHOP"] = 'https://www.deviantart.com/shop';
    URLS["STASH"] = 'https://sta.sh/';
    URLS["STATUS_UPDATES"] = 'https://www.deviantart.com/status-updates';
    URLS["SUBMISSION_POLICY"] = 'https://www.deviantart.com/about/policy/submission';
    URLS["SUBMIT"] = 'https://www.deviantart.com/submit/';
    URLS["SUBMIT_MURO"] = 'https://www.deviantart.com/muro/';
    URLS["TAG"] = 'https://www.deviantart.com/tag';
    URLS["TOS"] = 'https://www.deviantart.com/about/policy/service';
    URLS["WATCHING"] = 'https://www.deviantart.com/watching/';
    URLS["CHAT_HOME"] = 'https://www.deviantart.com/chat';
    URLS["CDN"] = 'https://st.deviantart.net';
    URLS["ART_STORE"] = 'https://www.popup-art.shop/';
    URLS["DMCA"] = 'https://contact.deviantartsupport.com/en?subOptionId=I-am-the-Copyright-holder.41656';
    URLS["DMCA_COUNTER"] = 'https://contact.deviantartsupport.com/en?subOptionId=I%27d-like-to-file-a-counter-DMCA61640';
    URLS["CUSTOMER_DASHBOARD"] = 'https://www.deviantart.com/account/customers';
    URLS["CHECKOUT_ERRORS"] = 'https://www.deviantartsupport.com/en/article/why-am-i-getting-an-issue-notification-when-i-try-to-purchase';
    URLS["PROTECT"] = 'https://www.deviantartprotect.com/';
    URLS["TEAM"] = 'https://www.deviantart.com/team';
    URLS["APP_PLAYSTORE_URL"] = 'https://play.google.com/store/apps/details?id=com.deviantart.android.damobile';
    URLS["DEVIANTART_SELL"] = 'https://www.deviantartsell.com/?utm_source=DA&utm_medium=banner&utm_campaign=DA_top_nav&utm_id=DA_top_nav';
    URLS[// Social links
    "DEVIANTART_INSTAGRAM"] = 'https://www.instagram.com/deviantart/';
    URLS["DEVIANTART_FACEBOOK"] = 'https://www.facebook.com/deviantart/';
    URLS["DEVIANTART_TWITTER"] = 'https://twitter.com/DeviantArt';
})(URLS || (URLS = {}));
var PROJECTS;
(function(PROJECTS) {
    PROJECTS["BROWSE"] = "BROWSE";
    PROJECTS["MESSAGECENTRE"] = "MESSAGECENTRE";
    PROJECTS["PROFILE"] = "PROFILE";
    PROJECTS["DEVIATION"] = "DEVIATION";
    PROJECTS["COMMENTS"] = "COMMENTS";
    PROJECTS["SISU"] = "SISU";
    PROJECTS["PONIES"] = "PONIES";
    PROJECTS["CHAT"] = "CHAT";
    PROJECTS["EDITOR"] = "EDITOR";
    PROJECTS["FEEDBACK"] = "FEEDBACK";
    PROJECTS["STASH"] = "STASH";
})(PROJECTS || (PROJECTS = {}));
var USER_PROFILE_SECTION_PATHS;
(function(USER_PROFILE_SECTION_PATHS) {
    USER_PROFILE_SECTION_PATHS["HOME"] = '';
    USER_PROFILE_SECTION_PATHS["ABOUT"] = 'about';
    USER_PROFILE_SECTION_PATHS["GALLERY"] = 'gallery';
    USER_PROFILE_SECTION_PATHS["SHOP"] = 'shop';
    USER_PROFILE_SECTION_PATHS["FAVOURITES"] = 'favourites';
    USER_PROFILE_SECTION_PATHS["PRIVATE_COLLECTIONS"] = 'private-collections';
    USER_PROFILE_SECTION_PATHS["POSTS"] = 'posts';
    USER_PROFILE_SECTION_PATHS["STATS"] = 'stats';
    USER_PROFILE_SECTION_PATHS["SUBSCRIPTIONS"] = 'subscriptions';
    USER_PROFILE_SECTION_PATHS["BACKROOM"] = 'backroom';
})(USER_PROFILE_SECTION_PATHS || (USER_PROFILE_SECTION_PATHS = {}));
var USER_PROFILE_SHOP_SUB_PATHS;
(function(USER_PROFILE_SHOP_SUB_PATHS) {
    USER_PROFILE_SHOP_SUB_PATHS["ALL"] = '';
    USER_PROFILE_SHOP_SUB_PATHS["ADOPTABLES"] = 'adoptables';
    USER_PROFILE_SHOP_SUB_PATHS["COMMISSIONS"] = 'commissions';
    USER_PROFILE_SHOP_SUB_PATHS["PRINTS"] = 'prints';
    USER_PROFILE_SHOP_SUB_PATHS["PREMIUM_CONTENT"] = 'premium_content';
    USER_PROFILE_SHOP_SUB_PATHS["PREMIUM_FOLDERS"] = 'premium_folders';
})(USER_PROFILE_SHOP_SUB_PATHS || (USER_PROFILE_SHOP_SUB_PATHS = {}));
var USER_PROFILE_POSTS_SUB_PATHS;
(function(USER_PROFILE_POSTS_SUB_PATHS) {
    USER_PROFILE_POSTS_SUB_PATHS["ALL"] = '';
    USER_PROFILE_POSTS_SUB_PATHS["JOURNALS"] = 'journals';
    USER_PROFILE_POSTS_SUB_PATHS["STATUSES"] = 'statuses';
    USER_PROFILE_POSTS_SUB_PATHS["POLLS"] = 'polls';
    USER_PROFILE_POSTS_SUB_PATHS["DRAFTS"] = 'drafts';
})(USER_PROFILE_POSTS_SUB_PATHS || (USER_PROFILE_POSTS_SUB_PATHS = {}));
var USER_PROFILE_BACKROOM_SUB_PATHS;
(function(USER_PROFILE_BACKROOM_SUB_PATHS) {
    USER_PROFILE_BACKROOM_SUB_PATHS["NOTES"] = '';
    USER_PROFILE_BACKROOM_SUB_PATHS["ACTION_LOG"] = 'actionlog';
    USER_PROFILE_BACKROOM_SUB_PATHS["MESSAGE_LOG"] = 'messagelog';
})(USER_PROFILE_BACKROOM_SUB_PATHS || (USER_PROFILE_BACKROOM_SUB_PATHS = {}));
var DEVIATION_PATHS;
(function(DEVIATION_PATHS) {
    DEVIATION_PATHS["DEVIATION"] = 'art';
    DEVIATION_PATHS["JOURNAL"] = 'journal';
    DEVIATION_PATHS["COMMISSION"] = 'commission';
    DEVIATION_PATHS["STATUS"] = 'status-update';
    DEVIATION_PATHS["POLL"] = 'poll';
    DEVIATION_PATHS["TIER"] = 'tier';
})(DEVIATION_PATHS || (DEVIATION_PATHS = {}));
var CONTACT_PAGE_ANCHOR_JUMP_POINTS;
(function(CONTACT_PAGE_ANCHOR_JUMP_POINTS) {
    CONTACT_PAGE_ANCHOR_JUMP_POINTS["DRILLDOWN"] = 'drilldown';
    CONTACT_PAGE_ANCHOR_JUMP_POINTS["ISSUE_RESPONSE"] = 'issue-response';
    CONTACT_PAGE_ANCHOR_JUMP_POINTS["FORM"] = 'form';
})(CONTACT_PAGE_ANCHOR_JUMP_POINTS || (CONTACT_PAGE_ANCHOR_JUMP_POINTS = {}));
var SHOP_PATHS;
(function(SHOP_PATHS) {
    SHOP_PATHS["DOWNLOADS"] = 'downloads';
    SHOP_PATHS["COMMISSIONS"] = 'commissions';
    SHOP_PATHS["SUBSCRIPTIONS"] = 'subscriptions';
})(SHOP_PATHS || (SHOP_PATHS = {}));
var CHECKOUT_IDS;
(function(CHECKOUT_IDS) {
    CHECKOUT_IDS[CHECKOUT_IDS["CAKE"] = 150647560] = "CAKE";
})(CHECKOUT_IDS || (CHECKOUT_IDS = {}));
